var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { VariantBoundary } from "./VariantBoundary.js";
const _VariantRange = class _VariantRange {
  constructor(lessThan, greaterThan) {
    /// <summary>
    /// Gets the upper bound. Values less than <see cref="VariantBoundary{T}.Value"/> are in the range.
    /// </summary>
    __publicField(this, "lessThan");
    /// <summary>
    /// Gets the lower bound. Values greater than <see cref="VariantBoundary{T}.Value"/> are in the range.
    /// </summary>
    __publicField(this, "greaterThan");
    this.lessThan = lessThan;
    this.greaterThan = greaterThan;
  }
  /// <summary>
  /// Gets the string representation of the range.
  /// </summary>
  /// <remarks>Round brackets <c>()</c> denote an open interval boundary - value is not included (e.g. <, >).
  /// Square brackets <c>[]</c> denote a closed interval boundary - value is included (e.g. <=, >=).
  /// An interval can be half-open, i.e. <c>[min, max)</c> or <c>(min, max]</c>.
  /// Either min or max boundary can be replaced with <c>null</c> to represent a range instead of a segment.
  /// </remarks>
  /// <returns>String representation of the range.</returns>
  toString() {
    var _a, _b;
    const builder = [];
    if (this.greaterThan != null) {
      builder.push(this.greaterThan.isClosed ? "[" : "(");
      builder.push(((_a = this.greaterThan.value) == null ? void 0 : _a.toString()) || "");
    } else {
      builder.push("(null");
    }
    builder.push(", ");
    if (this.lessThan != null) {
      builder.push(((_b = this.lessThan.value) == null ? void 0 : _b.toString()) || "");
      builder.push(this.lessThan.isClosed ? "]" : ")");
    } else {
      builder.push("null)");
    }
    return builder.join("");
  }
  equals(obj) {
    return this.equalsInner(this, obj);
  }
  equalsInner(x, y) {
    if (x === y) {
      return true;
    }
    if (x === null || y === null) {
      return false;
    }
    if (x.greaterThan === y.greaterThan && x.lessThan === y.lessThan) {
      return true;
    }
    if (x.greaterThan === null || x.lessThan === null || y.greaterThan === null || y.lessThan == null) {
      return false;
    }
    return x.greaterThan.equals(y.greaterThan) && x.lessThan.equals(y.lessThan);
  }
  static create(payload) {
    const { lessThan, greaterThan } = payload;
    if (lessThan == null && greaterThan == null) {
      return _VariantRange.Everything;
    }
    return new _VariantRange(lessThan, greaterThan);
  }
  static upperBound(lessThan, lessThanOrEqual, compareValues) {
    return _VariantRange.create({
      lessThan: new VariantBoundary(lessThan, lessThanOrEqual, compareValues),
      greaterThan: null
    });
  }
  static lowerBound(greaterThan, greaterThanOrEqual, compareValues) {
    return _VariantRange.create({
      lessThan: null,
      greaterThan: new VariantBoundary(greaterThan, greaterThanOrEqual, compareValues)
    });
  }
  static between(lessThan, lessThanOrEqual, greaterThan, greaterThanOrEqual, compareValues) {
    return _VariantRange.create({
      lessThan: new VariantBoundary(lessThan, lessThanOrEqual, compareValues),
      greaterThan: new VariantBoundary(greaterThan, greaterThanOrEqual, compareValues)
    });
  }
  static equalTo(value, compareValues) {
    return _VariantRange.between(value, true, value, true, compareValues);
  }
};
/// <summary>
/// Range that includes all values: <c>(null, null)</c>.
/// </summary>
__publicField(_VariantRange, "Everything", new _VariantRange(null, null));
let VariantRange = _VariantRange;
export {
  VariantRange
};
//# sourceMappingURL=VariantRange.js.map
